<template>
  <div class="login-container">
    <!-- 背景图模糊层 -->
    <div class="bg-layer"></div>

    <!-- 右上角语言切换 -->
    <div class="register-lang">
      <LangSwitcher @language-changed="onLanguageChanged" />
    </div>

    <!-- 登录卡片 -->
    <div class="login-card">
      <!-- Logo/标题区域 -->
      <div class="login-header">
        <h1 class="title">AI算力云</h1>
        <p class="subtitle">AI computing power cloud</p>
      </div>

      <!-- 登录表单 -->
      <form class="login-form" @submit.prevent="handleLogin">
        <div class="form-group">
          <div class="input-icon">
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path
                d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                fill="currentColor"
              />
            </svg>
          </div>
          <input
            type="text"
            v-model="username"
            placeholder="请输入账号名称"
            class="form-input"
            autocomplete="username"
          />
        </div>

        <div class="form-group">
          <div class="input-icon">
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path
                d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
                fill="currentColor"
              />
            </svg>
          </div>
          <input
            :type="showPassword ? 'text' : 'password'"
            v-model="password"
            placeholder="请输入账号密码"
            class="form-input"
            autocomplete="current-password"
          />
          <button type="button" class="password-toggle" @click="togglePassword">
            <svg v-if="showPassword" viewBox="0 0 24 24" width="20" height="20">
              <path
                d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                fill="currentColor"
              />
            </svg>
            <svg v-else viewBox="0 0 24 24" width="20" height="20">
              <path
                d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>

        <div class="form-options">
          <!-- <label class="remember-me">
            <input type="checkbox" v-model="rememberMe" />
            <span class="checkmark"></span>
            记住密码
          </label> -->
          <a
            href="#"
            class="forgot-password"
            @click.prevent="handleForgotPassword"
            >忘记密码</a
          >
        </div>

        <button type="submit" class="login-btn">
          登录
          <span class="btn-glow"></span>
        </button>
      </form>

      <!-- 底部装饰 -->
      <!-- <div class="login-footer">
        <span class="footer-line"></span>
        <p>© 2026 智慧城市 · 安全管理系统</p>
      </div> -->

      <!-- 去注册按钮 -->
      <div class="register-wrapper">
        <span class="register-text">还没有资格？</span>
        <button type="button" class="register-btn" @click="handleRegister">
          立即申请资格
          <span class="register-arrow">→</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import consts from "@/utils/consts.js";
import LangSwitcher from "@/components/LangSwitcher.vue";

export default {
  name: "LoginComponent",
  components: {
    LangSwitcher,
  },
  data() {
    return {
      username: "",
      password: "",
      rememberMe: false,
      showPassword: false,
    };
  },
  methods: {
    handleLogin() {
      if (!this.username || !this.password) {
        this.$message.warning("请输入账号和密码");
        return;
      }
      console.log("登录信息:", {
        username: this.username,
        password: this.password,
        rememberMe: this.rememberMe,
      });

      // 显示 loading 消息
      const loading = this.$message({
        message: "加载中...",
        iconClass: "el-icon-loading",
        duration: 0, // 0 表示不自动关闭
      });

      this.$api.user
        .login({
          email: this.username,
          passwd: this.password,
          // rememberMe: this.rememberMe,
        })
        .then((res) => {
          loading.close(); // 关闭 loading
          console.log(res);
          if (res.code === 1) {
            this.$message.error(res.msg);
            return;
          }

          localStorage.setItem(consts.KEY_TOKEN, res.data.token);
          localStorage.setItem(consts.KEY_INFO, JSON.stringify(res.data.info));

          this.$message.success("登录成功");
          this.$router.push({ name: "Index" });
        });

      // 这里可以调用登录接口
      // this.$router.push('/dashboard')
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    handleForgotPassword() {
      console.log("跳转到忘记密码页面");
      this.$router.push({ name: "ResetPassword" });
    },
    handleRegister() {
      console.log("跳转到注册页面");
      this.$router.push({ name: "Register" });
    },
  },
};
</script>

<style scoped>
/* ===== 容器 ===== */
.login-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  overflow: hidden;
}

/* ===== 背景图层（带模糊效果） ===== */
.bg-layer {
  position: absolute;
  inset: 0;
  background-image: url("@/assets/imgs/dlbj.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* filter: blur(6px) brightness(0.7); */
  /* -webkit-filter: blur(6px) brightness(0.7); */
  transform: scale(1.05);
  z-index: 0;
}

/* ===== 登录卡片 ===== */
.login-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 440px;
  padding: 48px 40px 36px;
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.login-card:hover {
  border-color: rgba(100, 200, 255, 0.2);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.6), 0 0 60px rgba(0, 150, 255, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
}

/* ===== 头部 ===== */
.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  color: #fff;
  margin-bottom: 16px;
  box-shadow: 0 8px 32px rgba(0, 100, 255, 0.3);
}

.title {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 2px;
  margin: 0 0 4px;
  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
}

.subtitle {
  font-size: 12px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 6px;
  margin: 0;
  text-transform: uppercase;
}

/* ===== 表单 ===== */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 16px;
  color: rgba(255, 255, 255, 0.35);
  z-index: 2;
  pointer-events: none;
  transition: color 0.3s;
}

.form-input {
  width: 100%;
  padding: 16px 16px 16px 48px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
  font-size: 15px;
  outline: none;
  transition: all 0.3s ease;
  font-family: inherit;
}

.form-input::placeholder {
  color: rgba(255, 255, 255, 0.3);
}

.form-input:focus {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(0, 150, 255, 0.5);
  box-shadow: 0 0 0 4px rgba(0, 100, 255, 0.1);
}

.form-group:focus-within .input-icon {
  color: #00b4ff;
}

.form-input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px rgba(0, 50, 100, 0.3) inset !important;
  -webkit-text-fill-color: #fff !important;
  border-color: rgba(0, 150, 255, 0.3);
}

.password-toggle {
  position: absolute;
  right: 14px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.35);
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s;
}

.password-toggle:hover {
  color: rgba(255, 255, 255, 0.7);
}

/* ===== 选项行 ===== */
.form-options {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 4px;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  cursor: pointer;
  user-select: none;
}

.remember-me input {
  display: none;
}

.checkmark {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  transition: all 0.3s ease;
  flex-shrink: 0;
  position: relative;
}

.remember-me input:checked + .checkmark {
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  border-color: #00b4ff;
}

.remember-me input:checked + .checkmark::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.forgot-password {
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s;
}

.forgot-password:hover {
  color: #00b4ff;
}

/* ===== 登录按钮 ===== */
.login-btn {
  position: relative;
  padding: 16px;
  margin-top: 8px;
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  border: none;
  border-radius: 12px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
  letter-spacing: 2px;
  font-family: inherit;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 100, 255, 0.35);
}

.login-btn:active {
  transform: translateY(0);
  box-shadow: 0 4px 20px rgba(0, 100, 255, 0.2);
}

.btn-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.15) 0%,
    transparent 60%
  );
  opacity: 0;
  transition: opacity 0.6s;
  pointer-events: none;
}

.login-btn:hover .btn-glow {
  opacity: 1;
}

/* ===== 底部 ===== */
.login-footer {
  margin-top: 32px;
  text-align: center;
}

.footer-line {
  display: block;
  width: 60px;
  height: 2px;
  margin: 0 auto 16px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  border-radius: 2px;
}

.login-footer p {
  color: rgba(255, 255, 255, 0.2);
  font-size: 12px;
  letter-spacing: 1px;
  margin: 0;
}

/* ===== 去注册按钮 ===== */
.register-wrapper {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.register-text {
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
}

.register-btn {
  background: transparent;
  border: none;
  color: #00b4ff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 6px 0;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.3s ease;
  font-family: inherit;
  position: relative;
}

.register-btn::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #00b4ff, #0066ff);
  transition: width 0.3s ease;
}

.register-btn:hover {
  color: #66ccff;
  transform: translateX(4px);
}

.register-btn:hover::after {
  width: 100%;
}

.register-arrow {
  display: inline-block;
  transition: transform 0.3s ease;
}

.register-btn:hover .register-arrow {
  transform: translateX(4px);
}

/* ===== 响应式适配 ===== */
@media (max-width: 480px) {
  .login-card {
    padding: 32px 20px 28px;
    border-radius: 16px;
  }

  .title {
    font-size: 22px;
  }

  .form-input {
    padding: 14px 14px 14px 42px;
    font-size: 14px;
  }

  .login-btn {
    padding: 14px;
    font-size: 15px;
  }

  .bg-layer {
    filter: blur(8px) brightness(0.6);
    -webkit-filter: blur(8px) brightness(0.6);
  }

  .register-wrapper {
    flex-direction: column;
    gap: 6px;
  }
}

/* ===== 滚动条美化 ===== */
::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}

/* ===== 右上角语言切换 ===== */
.register-lang {
  position: absolute;
  top: 20px;
  right: 24px;
  z-index: 10;
}
</style>
